/*
 * NOTE: This is a duplicate of the same file in app-builder, needed for
 * backporting preview to old UI. Use/edit the original instead.
 */

import hljs from 'highlight.js/lib/core'
import 'highlight.js/styles/monokai-sublime.css'

import hljsBash from 'highlight.js/lib/languages/bash'
import hljsDockerfile from 'highlight.js/lib/languages/dockerfile'
import hljsJs from 'highlight.js/lib/languages/javascript'
import hljsJson from 'highlight.js/lib/languages/json'
import hljsMd from 'highlight.js/lib/languages/markdown'
import hljsTxt from 'highlight.js/lib/languages/plaintext'
import hljsPython from 'highlight.js/lib/languages/python'
import hljsHtml from 'highlight.js/lib/languages/xml'
import hljsYaml from 'highlight.js/lib/languages/yaml'

hljs.registerLanguage('javascript', hljsJs)
hljs.registerLanguage('json', hljsJson)
hljs.registerLanguage('markdown', hljsMd)
hljs.registerLanguage('plaintext', hljsTxt)
hljs.registerLanguage('dockerfile', hljsDockerfile)
hljs.registerLanguage('bash', hljsBash)
hljs.registerLanguage('python', hljsPython)
hljs.registerLanguage('html', hljsHtml)
hljs.registerLanguage('yaml', hljsYaml)

/**
 * Highlight code
 *
 * @param {string} path - Full path of the file being highlighted
 * @param {string} contents - File contents
 * @returns {string} Valid HTML with highlighted code
 *
 * File type is determined from path (via file extension or direct
 * comparison). Unrecognized types are rendered as plain text (ie.
 * no highlighting).
 *
 * Content is escaped automatically so the result is safe to insert
 * directly into HTML.
 */
export default function highlight (path, contents) {
  const fn = path.toLowerCase()
  let lang = 'plaintext'

  if (fn.endsWith('.js')) lang = 'javascript'
  if (fn.endsWith('.json')) lang = 'json'
  if (fn.endsWith('.md')) lang = 'markdown'
  if (fn.endsWith('.py')) lang = 'python'
  if (fn.endsWith('.html')) lang = 'html'
  if (fn.endsWith('.yaml') || fn.endsWith('.yml')) lang = 'yaml'

  if (fn === '.babelrc') lang = 'json'
  if (fn === 'dockerfile') lang = 'dockerfile'
  if (fn === '.env' || fn === 'env.sample') lang = 'bash'

  const hl = hljs.highlight(contents, { language: lang })
  return hl.value
}



// WEBPACK FOOTER //
// ./src/helpers/highlight.js